import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

export interface FormulaireFile {
  file_id: number;
  file_name: string;
  file_extension: string;
  file_link: string;
}

export interface Formulaire {
  formulaire_id: number;
  formulaire_type: string;
  formulaire_code: string;
  formulaire_nom_fr: string;
  formulaire_nom_ar?: string;
  type_entite?: string;
  type_personne?: string;
  formulaire_status: string;
  formulaire_status_label?: string;
  documents?: any[];
  files?: FormulaireFile[];
}

@Injectable({ providedIn: 'root' })
export class FormulairesService {
  constructor(private api: ApiService) {}

  getFormulaires(search = '', type = '', code = ''): Observable<any> {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (type) params.set('type', type);
    if (code) params.set('code', code);
    const qs = params.toString();
    return this.api.get(`/api/communication/formulaires${qs ? '?' + qs : ''}`);
  }

  getFormulaireById(id: number): Observable<any> {
    return this.api.get(`/api/communication/formulaires/${id}`);
  }

  getNextCode(prefix: string): Observable<any> {
    return this.api.get(`/api/communication/formulaires/next-code?prefix=${encodeURIComponent(prefix)}`);
  }

  createFormulaire(formData: FormData): Observable<any> {
    return this.api.post('/api/communication/formulaires', formData);
  }

  updateFormulaire(id: number, body: { formulaire_nom_fr: string; formulaire_nom_ar?: string }): Observable<any> {
    return this.api.put(`/api/communication/formulaires/${id}`, body);
  }

  setStatus(id: number, status: 'ACTI' | 'INAC'): Observable<any> {
    return this.api.patch(`/api/communication/formulaires/${id}/status`, { status });
  }

  addFiles(id: number, formData: FormData): Observable<any> {
    return this.api.post(`/api/communication/formulaires/${id}/files`, formData);
  }

  deleteFile(formulaireId: number, fileId: number): Observable<any> {
    return this.api.delete(`/api/communication/formulaires/${formulaireId}/files/${fileId}`);
  }
}
